import { DatePickerProps } from './date-picker.props';

export const DatePickerPresets: DatePickerProps = {
  allowFutureDates: true,
  allowPastDates: true,
  displayFormat: 'MM/DD/YYYY',
  placeholder: 'mm/dd/yyyy',
};
